import { Component, OnInit, Injectable, Inject, PLATFORM_ID  } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterLink }          from '@angular/router';
import { Gallery, GalleryRef, GalleryItem, GalleryComponent, ImageItem, YoutubeItem } from '@ngx-gallery/core';
import { Lightbox } from '@ngx-gallery/lightbox';

declare var stackedCards;

@Component({
    selector: 'features',
    templateUrl: './features.component.html'
})
export class FeaturesComponent implements OnInit {
    items: GalleryItem[] = [];
    galleryId='warlordLightbox';
    lightboxGalleryRef: any;
    isLightBoxOpen=false;

    constructor(public gallery: Gallery, @Inject(PLATFORM_ID) private platform: any, public lightbox: Lightbox) { }
    stackedCard:any;

    ngOnInit() {
        if (isPlatformBrowser(this.platform)) {
            this.stackedCard = new stackedCards({
                selector: '.mycards',
                layout: "fanOut",
                transformOrigin: "bottom",
            });
            this.stackedCard.init();

            this.items = [
                new ImageItem({ src: 'assets/warlords/2.png', thumb: 'assets/warlords/2.png' }),
                new ImageItem({ src: 'assets/warlords/5.png', thumb: 'assets/warlords/5.png' }),
                new ImageItem({ src: 'assets/warlords/13.png', thumb: 'assets/warlords/13.png' }),
                new ImageItem({ src: 'assets/warlords/9.png', thumb: 'assets/warlords/9.png' }),
                new ImageItem({ src: 'assets/warlords/4.png', thumb: 'assets/warlords/4.png' }),
            ];

            this.lightboxGalleryRef = this.gallery.ref(this.galleryId);
            this.lightboxGalleryRef.load(this.items);
            this.lightboxGalleryRef.itemClick.subscribe((click) => {
                if(!this.isLightBoxOpen) {
                    this.lightbox.open(click, this.galleryId, {panelClass: 'fullscreen'});
                }
            });
            this.lightbox.opened.subscribe((id) => {
                if(id == this.galleryId) {
                    this.isLightBoxOpen = true;
                    this.lightboxGalleryRef.setConfig({
                        imageSize: 'contain',
                        nav: true,
                    });
                }
            });
            this.lightbox.closed.subscribe((id) => {
                if(id == this.galleryId) {
                    this.isLightBoxOpen = false;
                    this.lightboxGalleryRef.setConfig({
                        imageSize: 'contain',
                        nav: false
                    });
                }
            });
            if (isPlatformBrowser(this.platform)) {
                //this.lightboxGalleryRef.play();
            }
        }
    }

    showPrevious(): void {
        var lastEl = null;
        for(var i=0; i < this.stackedCard.els.length; i++) {
            var el = this.stackedCard.els[i];
            if(el.classList.contains('active') && lastEl != null) {
                lastEl.click();
            } else {
                lastEl = el;
            }
        }
    }

    showNext(): void {
        var clickNextElement = null;
        for(var i=0; i < this.stackedCard.els.length; i++) {
            var el = this.stackedCard.els[i];
            if(clickNextElement) {
                el.click();
                break;
            }
            if(el.classList.contains('active') ) {
                clickNextElement = true;
            }
        }
    }

    openLightBox(index) {
        this.lightbox.open(index, 'conceptLightbox');
    }

    showPrevGal(): any {
        this.lightboxGalleryRef.prev();
    }

    showNextGal(): any {
        this.lightboxGalleryRef.next();
    }

}
